import Footer from './layout/Footer';
import Header from './layout/Header';
import {
  useGlobalRefresh,
  REFRESH_TASK_MESSAGES,
} from '@/contexts/GlobalRefreshContext';
import { Loader2 } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { refreshing, currentTask } = useGlobalRefresh();
  const hasTasks = currentTask.length > 0;
  const activeTask = hasTasks ? currentTask[currentTask.length - 1] : null;
  const completedTasks = hasTasks ? currentTask.slice(0, -1) : [];

  return (
    <div
      className="min-h-screen bg-background flex flex-col"
      data-test-id="layout-container"
    >
      {/* Header with authentication */}
      <Header />

      {/* Main content */}
      <main className="flex-1" data-test-id="main-content">
        {children}
      </main>

      {/* Footer */}
      <Footer />

      {/* Loading Overlay - matching Client Page */}
      {refreshing && (
        <div
          className="fixed inset-0 backdrop-blur-sm z-50 flex items-center justify-center"
          data-test-id="loading-overlay"
        >
          <div className="bg-white rounded-lg shadow-xl p-8 flex flex-col items-center gap-4 min-w-[300px]">
            <Loader2 className="h-12 w-12 text-primary animate-spin" />
            <div className="text-center">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Refreshing Data
              </h3>
              {hasTasks && (
                <ul className="mt-4 space-y-2 text-sm text-gray-600">
                  {completedTasks.map((task, index) => (
                    <li
                      className="flex items-center gap-2 text-gray-400 line-through"
                      key={`${task}-${index}`}
                    >
                      <span className="h-2 w-2 rounded-full bg-gray-300" />
                      {REFRESH_TASK_MESSAGES[task]}
                    </li>
                  ))}
                  {activeTask && (
                    <li className="flex items-center gap-2 font-medium text-gray-900">
                      <span className="h-2 w-2 rounded-full bg-primary animate-pulse" />
                      {REFRESH_TASK_MESSAGES[activeTask]}
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
